var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "entity-form-view d-flex w-100 h-100 flex-column position-relative",
    },
    [
      _c("view-common", {
        ref: "common",
        attrs: { config: _vm.getViewCommonConfig() },
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          staticStyle: { display: "contents" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSave.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "d-flex p-3 bg-secondary-subtle rounded" }, [
            _vm.editableEntity.id !== null &&
            _vm.editableEntity.id !== undefined
              ? _c(
                  "div",
                  {
                    staticClass: "property id d-flex me-4",
                    attrs: { "property-name": "ID" },
                  },
                  [
                    _c("div", { staticClass: "label align-self-center pe-2" }, [
                      _vm._v("ID"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "value fw-bold",
                        attrs: { title: _vm.editableEntity.id },
                      },
                      [_vm._v(_vm._s(_vm.editableEntity.id))]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.editableEntity.id !== null &&
            _vm.editableEntity.id !== undefined
              ? _c(
                  "div",
                  {
                    staticClass: "property store d-flex me-4",
                    attrs: { "property-name": "Store" },
                  },
                  [
                    _c("div", { staticClass: "label align-self-center pe-2" }, [
                      _vm._v("Store"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "value fw-bold" }, [
                      _vm._v(_vm._s(_vm.editableEntity.meta.store)),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.editableEntity.id === null ||
            _vm.editableEntity.id === undefined
              ? _c("div", { staticClass: "col-auto me-4" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label pe-2",
                      attrs: { for: "entity-store" },
                    },
                    [_vm._v("Store")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            (_vm.editableEntity.id === null ||
              _vm.editableEntity.id === undefined) &&
            _vm.isRelation
              ? _c("div", { staticClass: "col-auto me-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "value fw-bold align-self-center",
                      staticStyle: { "line-height": "2.5rem" },
                    },
                    [_vm._v(_vm._s(_vm.editableEntity.meta.store))]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            (_vm.editableEntity.id === null ||
              _vm.editableEntity.id === undefined) &&
            _vm.isNode
              ? _c("div", { staticClass: "col-auto me-4" }, [
                  _c(
                    "select",
                    {
                      staticClass: "form-select",
                      attrs: { id: "entity-store" },
                      domProps: { value: _vm.editableEntity.meta.store },
                      on: {
                        change: function ($event) {
                          return _vm.onStoreSelect($event.target.value)
                        },
                      },
                    },
                    _vm._l(_vm.model.stores, function (store) {
                      return _c(
                        "option",
                        { key: store, domProps: { value: store } },
                        [_vm._v(_vm._s(store))]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isRelation && _vm.editableEntity.type
              ? _c(
                  "div",
                  {
                    staticClass: "property type d-flex me-4",
                    attrs: { "property-name": "Type" },
                  },
                  [
                    _c("div", { staticClass: "label align-self-center pe-2" }, [
                      _vm._v("Type"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "value fw-bold" }, [
                      _vm._v(_vm._s(_vm.editableEntity.type)),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isRelation
              ? _c(
                  "div",
                  {
                    staticClass: "property source d-flex me-4",
                    attrs: { "property-name": "From" },
                  },
                  [
                    _c("div", { staticClass: "label align-self-center pe-2" }, [
                      _vm._v("Start node:"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "value fw-bold" }, [
                      _vm._v(_vm._s(_vm.editableEntity.source)),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isRelation
              ? _c(
                  "div",
                  {
                    staticClass: "property target d-flex me-4",
                    attrs: { "property-name": "To" },
                  },
                  [
                    _c("div", { staticClass: "label align-self-center pe-2" }, [
                      _vm._v("End node:"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "value fw-bold" }, [
                      _vm._v(_vm._s(_vm.editableEntity.target)),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.isNode
            ? _c("div", { staticClass: "d-flex align-items-center my-1 p-2" }, [
                _c(
                  "label",
                  {
                    staticClass: "form-label mb-0 me-2",
                    attrs: { for: "entity-labels" },
                  },
                  [_vm._v("Labels")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editableEntity.labels,
                      expression: "editableEntity.labels",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", id: "entity-labels" },
                  domProps: { value: _vm.editableEntity.labels },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.editableEntity,
                        "labels",
                        $event.target.value
                      )
                    },
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isRelation &&
          (_vm.editableEntity.id === null ||
            _vm.editableEntity.id === undefined)
            ? _c("div", { staticClass: "my-1 p-2 d-flex align-items-center" }, [
                _c(
                  "label",
                  {
                    staticClass: "form-label mb-0 me-2",
                    attrs: { for: "entity-type" },
                  },
                  [_vm._v("Type")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editableEntity.type,
                      expression: "editableEntity.type",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", id: "entity-type" },
                  domProps: { value: _vm.editableEntity.type },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.editableEntity, "type", $event.target.value)
                    },
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "my-2 p-2" }, [_vm._v("Properties")]),
          _vm._v(" "),
          _c("ul", { staticClass: "nav nav-tabs mb-1" }, [
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.activeTab === "edit" },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onTabSwitch("edit")
                    },
                  },
                },
                [_vm._v("Edit")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.activeTab === "json" },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onTabSwitch("json")
                    },
                  },
                },
                [_vm._v("JSON")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tab-content flex my-1 p-2",
              staticStyle: { "overflow-y": "auto" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "tab-pane",
                  class: { "active show": _vm.activeTab === "edit" },
                },
                [
                  _c(
                    "table",
                    {
                      staticClass: "w-100",
                      staticStyle: { "table-layout": "fixed" },
                    },
                    [
                      _c(
                        "tbody",
                        _vm._l(
                          _vm.editableEntity.properties,
                          function (prop, index) {
                            return _c("tr", { key: index }, [
                              _c(
                                "td",
                                {
                                  staticClass: "align-top",
                                  staticStyle: { "min-width": "200px" },
                                  attrs: { width: "25%" },
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: prop.key,
                                        expression: "prop.key",
                                      },
                                    ],
                                    staticClass: "form-control key-input",
                                    class: {
                                      "fw-bold": _vm.isSpecialKey(prop.key),
                                    },
                                    attrs: { type: "text", placeholder: "Key" },
                                    domProps: { value: prop.key },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          prop,
                                          "key",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "align-top",
                                  staticStyle: {
                                    width: "150px",
                                    "min-width": "100px",
                                  },
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: prop.type,
                                          expression: "prop.type",
                                        },
                                      ],
                                      staticClass: "form-select",
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              prop,
                                              "type",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                          function ($event) {
                                            return _vm.onTypeChange(
                                              $event.target.value,
                                              index
                                            )
                                          },
                                        ],
                                      },
                                    },
                                    _vm._l(
                                      _vm.availableDataTypeOptions,
                                      function (opt) {
                                        return _c(
                                          "option",
                                          {
                                            key: opt.value,
                                            attrs: { title: opt.title },
                                            domProps: { value: opt.value },
                                          },
                                          [_vm._v(_vm._s(opt.label))]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _vm.getInputType(prop.type) == "codeeditor"
                                    ? _c("codemirror", {
                                        attrs: {
                                          options: _vm.getCmOptions(prop),
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onValueChange(
                                              $event,
                                              index
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.onValueLeave(index)
                                          },
                                        },
                                        model: {
                                          value: prop.inputValue,
                                          callback: function ($$v) {
                                            _vm.$set(prop, "inputValue", $$v)
                                          },
                                          expression: "prop.inputValue",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.getInputType(prop.type) === "checkbox"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: prop.inputValue,
                                            expression: "prop.inputValue",
                                          },
                                        ],
                                        staticClass: "form-check-input",
                                        staticStyle: {
                                          width: "20px",
                                          height: "20px",
                                          margin: "10px",
                                        },
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: Array.isArray(
                                            prop.inputValue
                                          )
                                            ? _vm._i(prop.inputValue, null) > -1
                                            : prop.inputValue,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a = prop.inputValue,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      prop,
                                                      "inputValue",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      prop,
                                                      "inputValue",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  prop,
                                                  "inputValue",
                                                  $$c
                                                )
                                              }
                                            },
                                            function ($event) {
                                              return _vm.onValueChange(
                                                $event.target.checked,
                                                index
                                              )
                                            },
                                          ],
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.getInputType(prop.type) === "number"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: prop.inputValue,
                                            expression: "prop.inputValue",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "number", step: "any" },
                                        domProps: { value: prop.inputValue },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onValueChange(
                                              $event.target.value,
                                              index
                                            )
                                          },
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              prop,
                                              "inputValue",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.getInputType(prop.type) === "date"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: prop.inputValue,
                                            expression: "prop.inputValue",
                                          },
                                        ],
                                        staticClass: "form-control w-auto",
                                        attrs: { type: "date" },
                                        domProps: { value: prop.inputValue },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onValueChange(
                                              $event.target.value,
                                              index
                                            )
                                          },
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              prop,
                                              "inputValue",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.getInputType(prop.type) === "localtime"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: prop.inputValue,
                                            expression: "prop.inputValue",
                                          },
                                        ],
                                        staticClass: "form-control w-auto",
                                        attrs: { type: "time", step: "1" },
                                        domProps: { value: prop.inputValue },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onValueChange(
                                              $event.target.value,
                                              index
                                            )
                                          },
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              prop,
                                              "inputValue",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.getInputType(prop.type) === "time"
                                    ? _c("MaskedInput", {
                                        staticClass: "form-control",
                                        attrs: {
                                          placeholder:
                                            "hh:mm:ss.nnnnnnnnn ±hh:mm",
                                          "slot-char": "mhsn±",
                                          accept: "[\\d\\+\\-]",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onValueChange(
                                              $event.target.value,
                                              index
                                            )
                                          },
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                          },
                                        },
                                        model: {
                                          value: prop.inputValue,
                                          callback: function ($$v) {
                                            _vm.$set(prop, "inputValue", $$v)
                                          },
                                          expression: "prop.inputValue",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.getInputType(prop.type) ===
                                  "localdatetime"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: prop.inputValue,
                                            expression: "prop.inputValue",
                                          },
                                        ],
                                        staticClass: "form-control w-auto",
                                        attrs: {
                                          type: "datetime-local",
                                          step: "1",
                                        },
                                        domProps: { value: prop.inputValue },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onValueChange(
                                              $event.target.value,
                                              index
                                            )
                                          },
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              prop,
                                              "inputValue",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.getInputType(prop.type) === "datetime"
                                    ? _c("MaskedInput", {
                                        staticClass: "form-control",
                                        attrs: {
                                          placeholder:
                                            "yyyy-mm-dd hh:mm:ss.nnnnnnnnn ±hh:mm",
                                          "slot-char": "dmyhsn±",
                                          accept: "[\\d\\+\\-]",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onValueChange(
                                              $event.target.value,
                                              index
                                            )
                                          },
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.preventDefault()
                                          },
                                        },
                                        model: {
                                          value: prop.inputValue,
                                          callback: function ($$v) {
                                            _vm.$set(prop, "inputValue", $$v)
                                          },
                                          expression: "prop.inputValue",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.getInputType(prop.type) === "fileupload"
                                    ? _c("div", [
                                        _c("input", {
                                          staticStyle: { display: "none" },
                                          attrs: {
                                            id: "file-upload-" + index,
                                            type: "file",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onFileChange(
                                                $event,
                                                index
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        prop.lastValidValue
                                          ? _c(
                                              "span",
                                              { staticClass: "mx-2" },
                                              [
                                                _vm._v(
                                                  _vm._s(prop.lastValidValue)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-primary",
                                            attrs: {
                                              type: "button",
                                              title: "Upload file",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.triggerFileUpload(
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-upload me-1",
                                            }),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "align-top ps-2",
                                  attrs: { width: "50px" },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-danger",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeProperty(index)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-solid fa-xmark",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          }
                        ),
                        0
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane",
                  class: { "active show": _vm.activeTab === "json" },
                },
                [
                  _c("codemirror", {
                    attrs: {
                      options: {
                        tabSize: 2,
                        mode: "application/json",
                        lineNumbers: true,
                        line: true,
                        lineWrapping: true,
                      },
                    },
                    model: {
                      value: _vm.jsonProperties,
                      callback: function ($$v) {
                        _vm.jsonProperties = $$v
                      },
                      expression: "jsonProperties",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex justify-content-between p-2" }, [
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.addProperty },
                },
                [
                  _c("i", { staticClass: "fa fa-plus me-1" }),
                  _vm._v(" Add Property"),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn btn-light",
                  attrs: { type: "button" },
                  on: { click: _vm.cancel },
                },
                [
                  _c("i", { staticClass: "fa-solid fa-xmark" }),
                  _vm._v(" Cancel"),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  attrs: { type: "button", disabled: !_vm.hasChanges },
                  on: { click: _vm.onApply },
                },
                [_c("i", { staticClass: "fa fa-check me-1" }), _vm._v(" Apply")]
              ),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      { staticClass: "btn btn-success", attrs: { type: "submit" } },
      [_c("i", { staticClass: "fa fa-edit me-1" }), _vm._v(" Save")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }